import { useTranslation } from 'react-i18next';

interface Props {
  onNavigate: (route: 'intake' | 'status' | 'privacidade' | 'treinamento') => void;
}

export function Footer({ onNavigate }: Props): JSX.Element {
  const { t } = useTranslation();
  return (
    <footer className="app-footer">
      <p>{t('footer.politica_nao_retaliacao')}</p>
      <p style={{ marginTop: 8 }}>
        <button className="footer-link" onClick={() => onNavigate('treinamento')}>
          {t('footer.treinamento_link')}
        </button>
        <span aria-hidden="true"> · </span>
        <button className="footer-link" onClick={() => onNavigate('privacidade')}>
          {t('footer.privacidade_link')}
        </button>
        <span aria-hidden="true"> · </span>
        {/* Era um `mailto:` para o endereço do Encarregado — que NÃO entregava
            (o domínio declara null MX + SPF -all). Um mailto morto é pior que
            link nenhum: a pessoa escreve, acha que falou com a empresa, e a
            mensagem some. Aponta para o próprio canal, que ao menos devolve
            protocolo e permite acompanhar. É PALIATIVO — a lacuna do art. 41
            segue ABERTA, registrada na fila de correção e no REVERTER-ANTES-DE-DIVULGAR.
            O endereço não é citado aqui de propósito: `dominio-morto.test.ts`
            barra a string no fonte para ninguém a copiar de volta. */}
        <button className="footer-link" onClick={() => onNavigate('intake')}>
          {t('footer.dpo_link')}
        </button>
      </p>
    </footer>
  );
}
